import React from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { CheckIcon } from 'lucide-react';
export function FoodCombos() {
  const combos = [{
    name: 'Combo Básico',
    price: '$45',
    description: 'Alimentos esenciales para el día a día',
    image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400&h=300&fit=crop',
    items: ['Arroz (5 lb)', 'Frijoles negros (2 lb)', 'Aceite vegetal (1 L)', 'Azúcar (2 lb)', 'Sal y especias']
  }, {
    name: 'Combo Proteínas',
    price: '$65',
    description: 'Carnes y embutidos de calidad',
    image: 'https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?w=400&h=300&fit=crop',
    items: ['Pollo (3 lb)', 'Cerdo (2 lb)', 'Salchichas (1 lb)', 'Jamón (1 lb)', 'Chorizo (500g)'],
    featured: true
  }, {
    name: 'Combo Desayuno',
    price: '$38',
    description: 'Todo para empezar el día con energía',
    image: 'https://images.unsplash.com/photo-1533089860892-a7c6f0a88666?w=400&h=300&fit=crop',
    items: ['Café (1 lb)', 'Leche en polvo (1 lb)', 'Pan de molde', 'Mantequilla (500g)', 'Mermelada']
  }, {
    name: 'Combo Premium',
    price: '$120',
    description: 'Selección completa de alimentos',
    image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=400&h=300&fit=crop',
    items: ['Todo del Combo Básico', 'Todo del Combo Proteínas', 'Todo del Combo Desayuno', 'Frutas enlatadas', 'Productos de limpieza']
  }];
  return <section id="combos" className="w-full bg-gradient-to-b from-gray-50 to-white py-16 md:py-24" data-id="element-25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="text-center mb-12" data-id="element-27">
          <div className="inline-block px-4 py-2 bg-red-100 text-red-600 rounded-full font-semibold mb-4" data-id="element-28">
            ¡Nuevo Servicio!
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4" data-id="element-29">
            Combos de Comida para Cuba
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-30">
            Alimenta a tu familia en Cuba, sin importar la distancia. Selecciona
            el combo perfecto y nosotros nos encargamos de todo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-31">
          {combos.map((combo, index) => <Card key={index} hover className={combo.featured ? 'ring-2 ring-red-600 relative' : ''} data-id="element-32">
              {combo.featured && <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-33">
                  <span className="bg-red-600 text-white px-4 py-1 rounded-full text-sm font-semibold shadow-lg" data-id="element-34">
                    Más Popular
                  </span>
                </div>}

              <div className="overflow-hidden rounded-t-xl" data-id="element-35">
                <img src={combo.image} alt={combo.name} className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-110" data-id="element-36" />
              </div>

              <div className="p-6" data-id="element-37">
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-38">
                  {combo.name}
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-39">{combo.description}</p>

                <div className="mb-6" data-id="element-40">
                  <div className="text-3xl font-bold text-red-600 mb-4" data-id="element-41">
                    {combo.price}
                  </div>

                  <ul className="space-y-2" role="list" data-id="element-42">
                    {combo.items.map((item, idx) => <li key={idx} className="flex items-start text-sm text-gray-700" data-id="element-43">
                        <CheckIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-44" />
                        <span data-id="element-45">{item}</span>
                      </li>)}
                  </ul>
                </div>

                <Button variant="primary" className="w-full" ariaLabel={`Enviar ${combo.name} a Cuba`} data-id="element-46">
                  Enviar a Cuba
                </Button>
              </div>
            </Card>)}
        </div>

        <div className="mt-12 text-center" data-id="element-47">
          <p className="text-gray-600 mb-4" data-id="element-48">
            ¿Necesitas un combo personalizado?
          </p>
          <Button variant="secondary" data-id="element-49">Contactar con un asesor</Button>
        </div>
      </div>
    </section>;
}